// todo: fix "export default from" syntax and use automatically gathered components 
// import Components from './components';

// export default Components;

import AnchorMenu from 'components/AnchorMenu';
import Footer from 'components/Footer';
import Header from 'components/Header';
import HeaderImageBlock from 'components/HeaderImageBlock';
import FeatureMediaHeader from "components/FeatureMediaHeader";
import LinkGroupListBlock from 'components/LinkGroupListBlock';
import FeatureListBlock from 'components/FeatureListBlock';
import TabListBlock from 'components/TabListBlock';
import VideoListBlock from 'components/VideoListBlock';
import TextBlock from 'components/TextBlock';
import InfographicListBlock from 'components/InfographicListBlock';
import ContactBlock from 'components/ContactBlock';
import ImageBlock from 'components/ImageBlock';
import QuoteBlock from 'components/QuoteBlock';
import Icons from 'components/Icons';
import TimelineBlock from 'components/TimelineBlock';
import EventCard from 'components/EventCard';
import ProjectListBlock from 'components/ProjectListBlock';
import DepartmentInformationBlock from 'components/DepartmentInformationBlock';
import ProjectInfoBlock from 'components/ProjectInfoBlock';
import VacancyListBlock from 'components/VacancyListBlock';
import CollaboratorLinksBlock from 'components/CollaboratorLinksBlock';
import SectionMenuBlock from 'components/SectionMenuBlock';
import LinkListBlock from 'components/LinkListBlock';
import NewsListBlock from 'components/NewsListBlock';
import ArticleListBlock from 'components/ArticleListBlock';
import BusinessAreaListBlock from 'components/BusinessAreaListBlock';
import VacanciesFilter from 'components/VacanciesFilter';
import HMSBlock from 'components/HMSBlock';
import SearchResultsBlock from 'components/SearchResultsBlock';
import TableBlock from 'components/TableBlock';
import DocumentListBlock from 'components/DocumentListBlock';
import DepartmentInformationListBlock from 'components/DepartmentInformationListBlock';
import FullscreenListBlock from 'components/FullscreenListBlock';
import PressReleaseBlock from 'components/PressReleaseBlock';
import WebcamBlock from 'components/WebcamBlock';
import WebcamBlockBody from 'components/WebcamBlockBody';
import DocumentFilterListBlock from 'components/DocumentFilterListBlock';
import ProjectListPage from 'components/ProjectListPage';
import BoardBlock from 'components/BoardBlock';
import GalleryBlock from 'components/GalleryBlock';
import MapBlock from 'components/MapBlock';
import MapLocationBlock from 'components/MapLocationBlock';
import ActiveProjectsMapBlock from 'components/ActiveProjectsMapBlock';
import CuriousBlock from 'components/CuriousBlock';
import CookieBlock from 'components/CookieBlock';
import YoutubeVideoBlock from 'components/YoutubeVideoBlock';
import BusinessAreaBlock from 'components/BusinessAreaBlock';
import BannersListBlock from 'components/BannersListBlock';
import Banner from 'components/Banner';
import TopText from 'components/TopText';
import SearchFormInline from 'components/SearchFormInline';
import ShortcutsBlock from 'components/ShortcutsBlock';
import RelatedArticles from 'components/RelatedArticles';
import FeatureArticlesFilter from 'components/FeatureArticlesFilter';
import FeatureArticleTextBlock from 'components/FeatureArticleTextBlock';
import FeatureArticleVacancyBlock from 'components/FeatureArticleVacancyBlock';
import FeatureLandingPageHeader from 'components/FeatureLandingPageHeader';
import FeatureArticleHeader from 'components/FeatureArticleHeader';
import HighlightedProjectBlock from 'components/HighlightedProjectBlock';
import TopicAreasNavigationBlock from 'components/TopicAreasNavigationBlock';
import RelatedArticleBlock from 'components/RelatedArticleBlock';
import DoYouHaveQuestionsBlock from 'components/DoYouHaveQuestionsBlock';
import CategoriesNavigation from 'components/CategoriesNavigation';
import DidntFindAnswer from 'components/DidntFindAnswer';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import VisitOurWebsiteBlock from 'components/VisitOurWebsiteBlock';
import ContactsList from 'components/ContactsList';
import CompanyList from 'components/CompanyList';
import GroupedLinksBlock from 'components/GroupedLinksBlock';
import FeatureMediaBlock from 'components/FeatureMediaBlock';
import InvestorHeader from 'components/InvestorHeader';
import NewImageBlock from 'components/NewImageBlock';
import InvestorBoardMembersBlock from 'components/InvestorBoardMembersBlock';
import ArticleTeaser from 'components/ArticleTeaser';
import InvestorDoubleReportBlock from 'components/InvestorDoubleReportBlock';
import InvestorReport from 'components/InvestorReport';
import InvestorFinancialCalendarBlock from 'components/InvestorFinancialCalendarBlock';
import InvestorPageHeading from 'components/InvestorPageHeading';

module.exports = {
    AnchorMenu,
    Footer,
    Header,
    HeaderImageBlock,
    LinkGroupListBlock,
    FeatureMediaHeader,
    FeatureListBlock,
    FeatureLandingPageHeader,
    TabListBlock,
    VideoListBlock,
    TextBlock,
    InfographicListBlock,
    ContactBlock,
    ImageBlock,
    QuoteBlock,
    Icons,
    TimelineBlock,
    EventCard,
    ProjectListBlock,
    ProjectInfoBlock,
    DepartmentInformationBlock,
    VacancyListBlock,
    CollaboratorLinksBlock,
    SectionMenuBlock,
    LinkListBlock,
    NewsListBlock,
    ArticleListBlock,
    BusinessAreaListBlock,
    VacanciesFilter,
    SearchResultsBlock,
    HMSBlock,
    TableBlock,
    DocumentListBlock,
    DepartmentInformationListBlock,
    FullscreenListBlock,
    PressReleaseBlock,
    WebcamBlock,
    WebcamBlockBody,
    DocumentFilterListBlock,
    ProjectListPage,
    BoardBlock,
    GalleryBlock,
    MapBlock,
    MapLocationBlock,
    ActiveProjectsMapBlock,
    CuriousBlock,
    CookieBlock,
    YoutubeVideoBlock,
    BusinessAreaBlock,
    BannersListBlock,
    Banner,
    TopText,
    SearchFormInline,
    ShortcutsBlock,
    RelatedArticles,
    FeatureArticlesFilter,
    FeatureArticleTextBlock,
    FeatureArticleVacancyBlock,
    FeatureArticleHeader,
    HighlightedProjectBlock,
    TopicAreasNavigationBlock,
    RelatedArticleBlock,
    DoYouHaveQuestionsBlock,
    CategoriesNavigation,
    DidntFindAnswer,
    Breadcrumbs,
    VisitOurWebsiteBlock,
    ContactsList,
    CompanyList,
    GroupedLinksBlock,
    FeatureMediaBlock,
    InvestorHeader,
    NewImageBlock,
    InvestorBoardMembersBlock,
    ArticleTeaser,
    InvestorDoubleReportBlock,
    InvestorReport,
    InvestorFinancialCalendarBlock,
    InvestorPageHeading
};



// WEBPACK FOOTER //
// ./src/components.js